export default __webpack_public_path__ + "static/media/how_it_works.8cc8360b.gif";